function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.125",
  d: "M6.996 11.003l4.006-4.006m.181 3.866a.225.225 0 11-.323 0 .225.225 0 01.323 0M7.14 6.813a.225.225 0 11-.323 0 .225.225 0 01.323 0"
}), /*#__PURE__*/React.createElement("rect", {
  width: "13.506",
  height: "13.506",
  x: "2.247",
  y: "2.247",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.125",
  rx: "3.75"
}));